import PageTopNavV2 from "components/PageTopNavV2";
import { ISectionMenuItem } from "components/PageTopNav";
import bgShop from "assets/bg-shop.jpg";
import NoFriendsCard from "./NoFriendsCard";
import { CardWrapper, Container, NoFriendsContent } from "./styles";

interface Props {
	bgImageUrl?: string;
	sectionMenuData?: ISectionMenuItem[];
	title?: string;
	subtitle?: string;
	subtitle2?: string;
	buttonText?: string;
	imageUrl?: string;
}

const NoFriendsLayout = ({
	bgImageUrl = bgShop,
	sectionMenuData = [],
	title,
	subtitle,
	subtitle2,
	buttonText,
	imageUrl
}: Props) => {
	return (
		<Container bgImageUrl={bgImageUrl}>
			<NoFriendsContent>
				<PageTopNavV2
					sectionMenuData={sectionMenuData}
					hasSectionBanner={false}
					transparentMainBackground={true}
				/>
				<CardWrapper>
					<NoFriendsCard
						title={title}
						subtitle={subtitle}
						subtitle2={subtitle2}
						buttonText={buttonText}
						imageUrl={imageUrl}
					/>
				</CardWrapper>
			</NoFriendsContent>
		</Container>
	);
};

export default NoFriendsLayout;
